// extracted by mini-css-extract-plugin
module.exports = {"layoutSlider":"slider_layoutSlider__10bks","menuItem":"slider_menuItem__3HAOG","menuItemSelected":"slider_menuItemSelected__2xwjX","base":"slider_base__30R7W"};